import React from "react";
import { useNavigate } from "react-router-dom";

export const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => navigate("/");
  const handleGoHome = () => navigate("/admin/dashboard");

  return (
    <section className="flex min-h-screen items-center justify-center bg-[#FFF1F6]">
      <div className="max-w-lg rounded-3xl border border-[#f7d9e4] bg-white px-6 py-12 text-center shadow-lg">
        {/* Icon Circle */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#B82863]/10">
          <span className="text-5xl font-bold text-[#B82863]">404</span>
        </div>

        <h1 className="mt-6 text-3xl font-bold text-[#B82863]">
          Page Not Found
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-gray-600">
          Oops! The page you're trying to reach doesn't exist or was moved.
          Let's help you get back on track.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex items-center justify-center gap-4">
          <button
            onClick={handleGoBack}
            className="rounded-full border border-[#B82863] px-5 py-2 w-32 text-sm font-medium text-[#B82863] transition hover:bg-[#B82863]/10"
          >
            Go Back
          </button>

          <button
            onClick={handleGoHome}
            className="rounded-full bg-[#B82863] px-6 py-2 w-32 text-sm font-medium text-white transition hover:bg-[#A11F56]"
          >
            Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
